import { render } from "./AddModuleModal.vue?vue&type=template&id=01aba9cb&scoped=true&ts=true"
import script from "./AddModuleModal.vue?vue&type=script&lang=ts"
export * from "./AddModuleModal.vue?vue&type=script&lang=ts"

import "./AddModuleModal.vue?vue&type=style&index=0&id=01aba9cb&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01aba9cb"]])

export default __exports__